import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { resetLoginFlag } from '../../slices/thunks';
import { formatLoginError, getLoginErrorTitle } from './loginErrorUtils';

const AUTO_DISMISS_MS = 6000;

const LoginErrorAlert = ({ error, visible }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(100);

  const dismiss = useCallback(() => {
    setShow(false);
    dispatch(resetLoginFlag());
  }, [dispatch]);

  useEffect(() => {
    if (visible && error) {
      setShow(true);
      setProgress(100);
    } else {
      setShow(false);
    }
  }, [visible, error]);

  useEffect(() => {
    if (!show) return undefined;

    const start = Date.now();
    const tick = setInterval(() => {
      const elapsed = Date.now() - start;
      const remaining = Math.max(0, 100 - (elapsed / AUTO_DISMISS_MS) * 100);
      setProgress(remaining);
      if (remaining <= 0) {
        clearInterval(tick);
        dismiss();
      }
    }, 50);

    const timer = setTimeout(dismiss, AUTO_DISMISS_MS);
    return () => {
      clearInterval(tick);
      clearTimeout(timer);
    };
  }, [show, dismiss]);

  if (!show || !error) return null;

  const message = formatLoginError(error);

  return (
    <div className='login-error-banner' role='alert' aria-live='assertive'>
      <div className='login-error-banner__icon'>
        <i className='ri-error-warning-line' aria-hidden='true' />
      </div>
      <div className='login-error-banner__content'>
        <p className='login-error-banner__title mb-1'>
          {getLoginErrorTitle(error)}
        </p>
        <p className='login-error-banner__message mb-0'>{message}</p>
      </div>
      <button
        type='button'
        className='login-error-banner__close'
        onClick={dismiss}
        aria-label='Dismiss error'
      >
        <i className='ri-close-line' aria-hidden='true' />
      </button>
      <div
        className='login-error-banner__progress'
        style={{ width: `${progress}%` }}
        aria-hidden='true'
      />
    </div>
  );
};

export default LoginErrorAlert;
